module.exports = __webpack_public_path__ + "img/chef.e405ce5d.png";